function ShowMenuImage() {
    if (!isMobileResolution()) {
        $("#MainMenu > ul > li").hover(function () {

            $BannerImage = $(this).find(".MenuBanner img");

            if ($BannerImage.attr("data-oimage") != undefined) {

                var Oiamge = $BannerImage.attr("data-oimage");
                $BannerImage.attr("src", Oiamge);
                $BannerImage.removeAttr("data-oimage");
            }
        });
    }
}

function MobileHeaderSetting() {
    $(document).on('click', "header .RightAccount", function (e) {
        if (isMobile(true)) {
            var IsLogged = $(this).hasClass("Logged");

            if (IsLogged) {
                var isCartActive = $(".RightAccount").hasClass("active");

                if (isCartActive) {
                    $("body").removeClass("BackDropped");
                    $(".RightAccount").removeClass("active");
                    $(".RightBasket").addClass("active");
                }
                else {
                    $("body").addClass("BackDropped");
                    $(".RightAccount").addClass("active");
                    $(".RightBasket").removeClass("active");
                }

                //e.preventDefault;
                //return false;
            }
        }
    });

    if (isMobileResolution()) {
        $(".Mainmenu .itemsWrapper .ListWrapper > li > ul > li > ul").each(function () {
            if ($(this).find("li").length <= 0) {
                $(this.remove());
            }
        });

        $("#MainMenu .Mainmenu li.logo").remove();
        $("#MainMenu .Mainmenu .itemsWrapper .ListWrapper > li").unwrap();

        //$("#MainMenu ul.Mainmenu > li > a").each(function () {
        //    $(".Mobilmenu ul").append("<li>" + $(this)[0].outerHTML + "</li>");
        //});

        $("#MainMenu ul.Mainmenu > li").each(function () {
            $(".Mobilmenu > nav > ul").append($(this)[0].outerHTML);
        });

        $(".Mobilmenu > nav > ul > li").each(function () {
            if ($(this).find("> .itemsWrapper").length > 0) {
                $(this).addClass("wrapper");
            }
        });

        //$(".Mobilmenu").css("top", $("header").height() + "px");

        $(document).on("click", "header .MainControlOuther .burger-menu", function () {
            $(this).toggleClass("open");
            $("body > .Mobilmenu").toggleClass("open");
            $("body").toggleClass("no-scroll");
        });

        $(document).on("click", "body > .Mobilmenu .closeMobilMenu", function () {
            $("body > .Mobilmenu").removeClass("open");
            $("body > .Mobilmenu > nav > ul").removeClass("open");
            $("body > .Mobilmenu > nav > ul > li").removeClass("open");
            $("body > .Mobilmenu > nav > ul > li > ul").removeClass("open");

            $("body > .Mobilmenu .backMobilMenu").removeClass("show");
            $("body").removeClass("no-scroll");
        });

        $(document).on("click", "body > .Mobilmenu > nav > ul > li:not(.direct-link) > a", function () {
            $(this).closest(".menu-item").toggleClass("open");

            return false;
        });

        //$(document).on("click", "body > .Mobilmenu > nav > ul > li:not(.direct-link) > a", function () {

        //    $(this).

        //    return false;
        //});


        //$('#MainMenu .Mainmenu').hcOffcanvasNav({
        //    maxWidth: 992,
        //    levelSpacing: 20,
        //    navClass: 'MobilLeftMenu',
        //    labelClose: getStandartMessages("Kapat"),
        //    labelBack: getStandartMessages("Geri"),
        //    position: 'left'
        //});
    }
}

function DesktopHeaderSetting() {
    if (!isMobileResolution()) {
        $("#MainMenu > ul > li").live({
            mouseenter:
                function () {
                    if ($(this).find(".itemsWrapper").length > 0 && !$("#RegisterLoginModal").is(":visible")) {
                        $("body").addClass("BackDropped");
                    }
                },
            mouseleave:
                function () {
                    if ($(".SearchModal").css("display") != "block") {
                        $("body").removeClass("BackDropped");
                        $("ul#MainMenu.Monitor > li").removeClass("open");
                    }
                }
        });

        $(".RightAccount").live({
            mouseenter:
                function () {
                    if ($(this).find("#AccountMenu").length > 0) {
                        $("body").addClass("BackDropped");
                    }
                },
            mouseleave:
                function () {
                    if ($(".SearchModal").css("display") != "block") {
                        $("body").removeClass("BackDropped");
                        $("ul#MainMenu.Monitor > li").removeClass("open");
                    }
                }
        });
    }
}

function MenuBannerSettings() {
    $DefaultImage = "";

    $(".ListWrapper > li").hover(function () {
        $BannerArea = $(this).parent().parent().find(".MenuBanner > img");
        $DefaultImage = $BannerArea.attr("src");

        if ($(this).data("img") != "" && $(this).data("img") != null) {
            $BannerArea.attr("src", $(this).data("img"));

        }
    }, function () {
        $BannerArea.attr("src", $DefaultImage);
    });
}

function HideOpenWindows() {
    $(".RightAccount ").removeClass("active");
    $("ul#MainMenu.Monitor > li").removeClass("open");

    $("ul#MainMenu.Monitor > li").removeClass("open");
}

function SearchAreaControl() {
    if ($("body > .searchArea").length > 0 && !isMobileResolution()) {
        var headerHeight = $("header").height();
        var WindowHeight = $(window).height();

        $("body > .searchArea").css("top", headerHeight + "px");
        $("body > .searchArea").css("height", (WindowHeight - headerHeight) + "px");

        $("body > .searchArea").toggleClass("closed");
        $("body").toggleClass("has-search");

        setTimeout(function () {
            $("body > .searchArea .SearchInputBox input").focus();
        }, 400);

        if ($("body > .searchArea .SearchProduct .AutoGetLastVisited .SuggestedProducts").length == 0) {
            var LastVisitedPrds = GetLastVisitedData();

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
                GetLastVisitedPrdView(LastVisitedPrds, function (dt) {
                    if (dt != "") {
                        $("body > .searchArea .SearchProduct .AutoGetLastVisited").append(dt);

                        if ($(".searchArea .SearchProduct .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts").length > 0) {
                            $(".searchArea .SearchProduct .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .Prd").removeClass("col-xl-8").removeClass("col-lg-8").addClass("col-xl-6").addClass("col-lg-6");

                            SlickSlider("search");
                        }
                    }
                });
            }
        }
    }
    else if (isMobileResolution()) {
        $("header #UserMenus .RightSearch .SearchWrapper_New").toggleClass("open");

        if ($("header #UserMenus .RightSearch .SearchWrapper_New").hasClass("open")) {
            $("header #UserMenus .RightSearch .SearchWrapper_New #search").focus();
        }
        else {
            $("header #UserMenus .RightSearch .SearchWrapper_New #search").focusout();
        }
    }
}

$(document).ready(function () {
    ShowMenuImage();
    MobileHeaderSetting();
    DesktopHeaderSetting();
    MenuBannerSettings();

    //$(window).scroll(function () {
    //    if ($(window).scrollTop() >= 1) {
    //        $("header").addClass("fixed-menu");
    //    }
    //    else {
    //        $("header").removeClass("fixed-menu");
    //    }
    //});

    var isDesktop = true;
    if (isMobileResolution()) {
        isDesktop = false;
    }

    $(window).resize(function () {
        setTimeout(function () {
            setContentHeight();
        }, 1000);

        if (isMobileResolution() && isDesktop) {
            location.reload();
        }
        else if (!isMobileResolution() && !isDesktop) {
            location.reload();
        }
    });

    $(document).on("click", "header #UserAndBasket .RightSearch .headerSearchButton", function () {
        $("header .SearchArea").toggleClass("active");

        if ($("header .SearchArea").hasClass("active")) {
            $("header .SearchArea .SearchAreaInput .SearchAreaForm .SearchInput").focus();
        }
    });

    $(document).on("click", "header .SearchArea .SearchAreaInput .close-icon", function () {
        $("header .SearchArea").removeClass("active");
    });

    // Menu Events
    $('.RightBasket .SepetButton a').live('click', function (e) {
        //if (!isMobile(true)) {
        e.preventDefault();
        toggleBasket();
        //}
    });

    $('.RightBasket .SepetProducts .CartTitle .mobile-times').live('click', function (e) {
        if (isMobileResolution()) {
            toggleBasket();
        }
    });

    if ($("#UserAndBasket").length > 0) {
        GetSepetIcerik(function (dt) {
            $("#UserAndBasket").html(dt);
        });
    }

    $(".BasketContainer .RemoveIcon").live("click", function () {
        var LangID = $("#LangID").val();
        var dataall = "";
        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {
            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }

        if ($(this).attr("data-all") == "true") {
            dataall = "&all=true";
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        RemoveFromCardForMiniCard(Silid, LangID, dataall);
    });
    // Menu Events
});